// extracted by mini-css-extract-plugin
export default {"form":"CreateCourse_form__s6Bp8","formInputBlock":"CreateCourse_formInputBlock__f3O9P","formInput":"CreateCourse_formInput__DHZki","copyLinkBtn":"CreateCourse_copyLinkBtn__JOyP4"};